import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';

import { useDispatcher } from '../../../../store.decorator';
import { View } from '../../enum/view.enum';
import { setNoteViaSummary } from '../../state/set-note-via-summary.action';
import { switchView } from '../../state/switch-view.action';
import { TranscriptDialogService } from '../../transcript-dialog.service';

import { TranslationKeyMap } from './summary.i18n';

@Component({
    selector: 'cmps-transcript-dialog-summary',
    templateUrl: './summary.component.html',
})
export class SummaryComponent implements OnDestroy {
    @Output() summaryChange: EventEmitter<string>;

    /** @private */ _i18n = TranslationKeyMap;

    constructor(/** @private */ readonly _service: TranscriptDialogService) {
        this.summaryChange = new EventEmitter<any>();
    }

    ngOnDestroy(): void {
        this.summaryChange.complete();
    }

    /** @private */
    _onAddCommitmentNoteClick(): void {
        useDispatcher(
            this._service,
            setNoteViaSummary({
                commitment: true,
                observation: false,
            }),
        );
        if (this._service.state.view === View.LANDING) {
            useDispatcher(this._service, switchView({ view: View.NOTES }));
        }
    }

    /** @private */
    _onAddObservationNoteClick(): void {
        useDispatcher(
            this._service,
            setNoteViaSummary({
                commitment: false,
                observation: true,
            }),
        );
        if (this._service.state.view === View.LANDING) {
            useDispatcher(this._service, switchView({ view: View.NOTES }));
        }
    }
}
